import { render, staticRenderFns } from "./SlSingleSelect.vue?vue&type=template&id=3f5b666e&"
import script from "./SlSingleSelect.vue?vue&type=script&lang=js&"
export * from "./SlSingleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports